import axios from "axios";
import { VendorService_URL } from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../auth/actions";

var map = new HashMap();

function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

// Save IndustryType
export const saveIndustryTypeActions = {
  SAVE_INDUSTRY_TYPE: "SAVE_INDUSTRY_TYPE",
  SAVE_INDUSTRY_TYPE_STATUS: "SAVE_INDUSTRY_TYPE_STATUS",
  SAVE_INDUSTRY_TYPE_SUCCESS: "SAVE_INDUSTRY_TYPE_SUCCESS",
  SAVE_INDUSTRY_TYPE_FAILURE: "SAVE_INDUSTRY_TYPE_FAILURE",
};

export function saveIndustryTypeRequest() {
  return {
    type: saveIndustryTypeActions.SAVE_INDUSTRY_TYPE,
    isPosting: true,
  };
}

export function saveIndustryTypeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveIndustryTypeActions.SAVE_INDUSTRY_TYPE_SUCCESS,
      payload: props,
    });
  };
}

export function saveIndustryTypeFailure(error) {
  return {
    type: saveIndustryTypeActions.SAVE_INDUSTRY_TYPE_FAILURE,
    payload: error,
  };
}

export function saveIndustryTypeError(error) {
  return {
    type: saveIndustryTypeActions.SAVE_INDUSTRY_TYPE_FAILURE,
    payload: error,
  };
}

export function saveIndustryType(props) {
  var value = {
    industryTypeId: props.industryTypeId || 0,
    industryTypeName: props.industryTypeName,
  };

  return (dispatch) =>
    axios({
      method: "post",
      data: value,
      url: `${VendorService_URL}/Apc_Persist/Amc_85/saveIndustryType`,
      headers: {
        authorization: "Bearer " + props.access_token,
      },
    })
      .then((response) => {
        dispatch(saveIndustryTypeRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveIndustryTypeSuccess(response));
          return response;
        } else if (response.status === 401) {
        } else {
          const error = new Error(response.statusText);
          dispatch(saveIndustryTypeError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (err = ele));
          return err;
        } else {
          dispatch(clearLogoutData());
        }
      });
}

// clear  details
export const ClearFormDetailsActions = {
  CLEAR_FORM_DETAILS: "CLEAR_FORM_DETAILS",
};

export function clearFormData() {
  return (dispatch) => dispatch(clearFormDetails());
}

export function clearFormDetails() {
  return {
    type: ClearFormDetailsActions.CLEAR_FORM_DETAILS,
  };
}

// get industry details by id
export const GetIndustryTypeDetailsActions = {
  FETCH_INDUSTRY_TYPE_DETAILS: "FETCH_INDUSTRY_TYPE_DETAILS",
  FETCH_INDUSTRY_TYPE_DETAILS_STATUS: "FETCH_INDUSTRY_TYPE_DETAILS_STATUS",
  FETCH_INDUSTRY_TYPE_DETAILS_FULFILLED:
    "FETCH_INDUSTRY_TYPE_DETAILS_FULFILLED",
  FETCH_INDUSTRY_TYPE_DETAILS_REJECTED: "FETCH_INDUSTRY_TYPE_DETAILS_REJECTED",
};

export function getIndustryTypeDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url:
        `${VendorService_URL}/Apc_View/Amc_85/findIndustryTypeById?industryTypeId=` +
        params.industryTypeID,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getIndustryTypeDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getIndustryTypeDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getIndustryTypeDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getIndustryTypeDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getIndustryTypeDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getIndustryTypeDetailsError(err));
              break;
            case 500:
              dispatch(getIndustryTypeDetailsError("Server Error"));
              break;
            default:
              dispatch(getIndustryTypeDetailsError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getIndustryTypeDetailsRequest() {
  return {
    type: GetIndustryTypeDetailsActions.FETCH_INDUSTRY_TYPE_DETAILS,
    isPosting: true,
  };
}
export function getIndustryTypeDetailsError(error) {
  return {
    type: GetIndustryTypeDetailsActions.FETCH_INDUSTRY_TYPE_DETAILS_REJECTED,
    payload: error,
  };
}

export function getIndustryTypeDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetIndustryTypeDetailsActions.FETCH_INDUSTRY_TYPE_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getIndustryTypeDetailsStatus() {
  return (dispatch) => dispatch(getIndustryTypeDetailsStatusRequest());
}
export function getIndustryTypeDetailsStatusRequest() {
  return {
    type: GetIndustryTypeDetailsActions.FETCH_INDUSTRY_TYPE_DETAILS_STATUS,
  };
}

//GET Active Vendor Industry List
export const GetActiveIndustryTypeActions = {
  FETCH_ACTIVE_INDUSTRY_TYPE: "FETCH_ACTIVE_INDUSTRY_TYPE",
  FETCH_ACTIVE_INDUSTRY_TYPE_STATUS: "FETCH_ACTIVE_INDUSTRY_TYPE_STATUS",
  FETCH_ACTIVE_INDUSTRY_TYPE_FULFILLED: "FETCH_ACTIVE_INDUSTRY_TYPE_FULFILLED",
  FETCH_ACTIVE_INDUSTRY_TYPE_REJECTED: "FETCH_ACTIVE_INDUSTRY_TYPE_REJECTED",
};

export function getActiveIndustryTypeList(params) {
  return (dispatch) =>
    axios({
      method: "POST",
      url: `${VendorService_URL}/Apc_View/Amc_89/getAllIndustryTypeByCompanyId?companyId=${params.companyId}`,
      headers: {
        transactionId: "1",
        "Content-Type": "application/json",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getActiveIndustryTypeListRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getActiveIndustryTypeListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getActiveIndustryTypeListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveIndustryTypeListError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveIndustryTypeListError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveIndustryTypeListError(err));
              break;
            case 500:
              dispatch(getActiveIndustryTypeListError("Server Error"));
              break;
            default:
              dispatch(getActiveIndustryTypeListError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getActiveIndustryTypeListRequest() {
  return {
    type: GetActiveIndustryTypeActions.FETCH_ACTIVE_INDUSTRY_TYPE,
    isPosting: true,
  };
}
export function getActiveIndustryTypeListError(error) {
  return {
    type: GetActiveIndustryTypeActions.FETCH_ACTIVE_INDUSTRY_TYPE_REJECTED,
    payload: error,
  };
}

export function getActiveIndustryTypeListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetActiveIndustryTypeActions.FETCH_ACTIVE_INDUSTRY_TYPE_FULFILLED,
      payload: props,
    });
  };
}

export function getActiveIndustryTypeListStatus() {
  return (dispatch) => dispatch(getActiveIndustryTypeListStatusRequest());
}
export function getActiveIndustryTypeListStatusRequest() {
  return {
    type: GetActiveIndustryTypeActions.FETCH_ACTIVE_INDUSTRY_TYPE_STATUS,
  };
}

//SAVE VENDOR TYPE
export const SaveVendorTypeActions = {
  SAVE_VENDOR_TYPE: "SAVE_VENDOR_TYPE",
  SAVE_VENDOR_TYPE_STATUS: "SAVE_VENDOR_TYPE_STATUS",
  SAVE_VENDOR_TYPE_SUCCESS: "SAVE_VENDOR_TYPE_SUCCESS",
  SAVE_VENDOR_TYPE_FAILURE: "SAVE_VENDOR_TYPE_FAILURE",
};

export function SaveVendorTypeRequest() {
  return {
    type: SaveVendorTypeActions.SAVE_VENDOR_TYPE,
    isPosting: true,
  };
}

export function SaveVendorTypeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: SaveVendorTypeActions.SAVE_VENDOR_TYPE_SUCCESS,
      payload: props,
    });
  };
}

export function SaveVendorTypeFailure(error) {
  return {
    type: SaveVendorTypeActions.SAVE_VENDOR_TYPE_FAILURE,
    payload: error,
  };
}

export function SaveVendorTypeError(error) {
  return {
    type: SaveVendorTypeActions.SAVE_VENDOR_TYPE_FAILURE,
    payload: error,
  };
}

export function saveVendorType(props) {
  var value = {
    id: props.vendorTypeId || null,
    name: props.vendorTypeName,
    description: props.vendorTypeDesc,
  };

  return (dispatch) =>
    axios({
      method: "post",
      data: value,
      url: `${VendorService_URL}/Apc_View/Amc_86/saveVendorType`,
      headers: {
        authorization: "Bearer " + props.access_token,
      },
    })
      .then((response) => {
        dispatch(SaveVendorTypeRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(SaveVendorTypeSuccess(response));
          return response;
        } else if (response.status >= 401 && response.status < 500) {
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(SaveVendorTypeError(error));
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (err = ele));
          return err;
        } else {
          dispatch(clearLogoutData());
        }
      });
}

//GET VENDOR TYPE BY ID
export const GetVendorTypeDetailsActions = {
  FETCH_VENDOR_TYPE_DETAILS: "FETCH_VENDOR_TYPE_DETAILS",
  FETCH_VENDOR_TYPE_DETAILS_STATUS: "FETCH_VENDOR_TYPE_DETAILS_STATUS",
  FETCH_VENDOR_TYPE_DETAILS_FULFILLED: "FETCH_VENDOR_TYPE_DETAILS_FULFILLED",
  FETCH_VENDOR_TYPE_DETAILS_REJECTED: "FETCH_VENDOR_TYPE_DETAILS_REJECTED",
};

export function getVendorTypeDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url:
        `${VendorService_URL}/Apc_View/Amc_86/findVendorTypeById?id=` +
        params.vendorTypeId,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getVendorTypeDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getVendorTypeDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getVendorTypeDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorTypeDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorTypeDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorTypeDetailsError(err));
              break;
            case 500:
              dispatch(getVendorTypeDetailsError("Server Error"));
              break;
            default:
              dispatch(getVendorTypeDetailsError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getVendorTypeDetailsRequest() {
  return {
    type: GetVendorTypeDetailsActions.FETCH_VENDOR_TYPE_DETAILS,
    isPosting: true,
  };
}
export function getVendorTypeDetailsError(error) {
  return {
    type: GetVendorTypeDetailsActions.FETCH_VENDOR_TYPE_DETAILS_REJECTED,
    payload: error,
  };
}

export function getVendorTypeDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetVendorTypeDetailsActions.FETCH_VENDOR_TYPE_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getVendorTypeDetailsStatus() {
  return (dispatch) => dispatch(getVendorTypeDetailsStatusRequest());
}

export function getVendorTypeDetailsStatusRequest() {
  return {
    type: GetVendorTypeDetailsActions.FETCH_VENDOR_TYPE_DETAILS_STATUS,
  };
}

//GET Active Vendor Type List
export const GetActiveVendorTypeActions = {
  FETCH_ACTIVE_VENDOR_TYPE: "FETCH_ACTIVE_VENDOR_TYPE",
  FETCH_ACTIVE_VENDOR_TYPE_STATUS: "FETCH_ACTIVE_VENDOR_TYPE_STATUS",
  FETCH_ACTIVE_VENDOR_TYPE_FULFILLED: "FETCH_ACTIVE_VENDOR_TYPE_FULFILLED",
  FETCH_ACTIVE_VENDOR_TYPE_REJECTED: "FETCH_ACTIVE_VENDOR_TYPE_REJECTED",
};

export function getActiveVendorTypeList(params) {
  return (dispatch) =>
    axios({
      method: "POST",
      url: `${VendorService_URL}/Apc_View/Amc_89/getAllVendorTypeByCompanyId?companyId=${params.companyId}`,
      headers: {
        transactionId: "1",
        "Content-Type": "application/json",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getActiveVendorTypeListRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getActiveVendorTypeListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getActiveVendorTypeListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveVendorTypeListError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveVendorTypeListError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveVendorTypeListError(err));
              break;
            case 500:
              dispatch(getActiveVendorTypeListError("Server Error"));
              break;
            default:
              dispatch(getActiveVendorTypeListError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getActiveVendorTypeListRequest() {
  return {
    type: GetActiveVendorTypeActions.FETCH_ACTIVE_VENDOR_TYPE,
    isPosting: true,
  };
}
export function getActiveVendorTypeListError(error) {
  return {
    type: GetActiveVendorTypeActions.FETCH_ACTIVE_VENDOR_TYPE_REJECTED,
    payload: error,
  };
}

export function getActiveVendorTypeListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetActiveVendorTypeActions.FETCH_ACTIVE_VENDOR_TYPE_FULFILLED,
      payload: props,
    });
  };
}

export function getActiveVendorTypeListStatus() {
  return (dispatch) => dispatch(getActiveVendorTypeListStatusRequest());
}
export function getActiveVendorTypeListStatusRequest() {
  return {
    type: GetActiveVendorTypeActions.FETCH_ACTIVE_VENDOR_TYPE_STATUS,
  };
}

//--------------------------------------------------------------//
//SAVE VENDOR CATEGORY
export const SaveVendorCategoryActions = {
  SAVE_VENDOR_CATEGORY: "SAVE_VENDOR_CATEGORY",
  SAVE_VENDOR_CATEGORY_STATUS: "SAVE_VENDOR_CATEGORY_STATUS",
  SAVE_VENDOR_CATEGORY_SUCCESS: "SAVE_VENDOR_CATEGORY_SUCCESS",
  SAVE_VENDOR_CATEGORY_FAILURE: "SAVE_VENDOR_CATEGORY_FAILURE",
};

export function SaveVendorCategoryRequest() {
  return {
    type: SaveVendorCategoryActions.SAVE_VENDOR_CATEGORY,
    isPosting: true,
  };
}

export function SaveVendorCategorySuccess(props) {
  return (dispatch) => {
    dispatch({
      type: SaveVendorCategoryActions.SAVE_VENDOR_CATEGORY_SUCCESS,
      payload: props,
    });
  };
}

export function SaveVendorCategoryFailure(error) {
  return {
    type: SaveVendorCategoryActions.SAVE_VENDOR_CATEGORY_FAILURE,
    payload: error,
  };
}

export function SaveVendorCategoryError(error) {
  return {
    type: SaveVendorCategoryActions.SAVE_VENDOR_CATEGORY_FAILURE,
    payload: error,
  };
}

export function saveVendorCategory(props) {
  var value = {
    vendorCategoryId: props.vendorCategoryId || null,
    vendorCategoryName: props.vendorCategoryName,
    vendorCategoryDesc: props.vendorCategoryDesc,
  };

  return (dispatch) =>
    axios({
      method: "post",
      data: value,
      url: `${VendorService_URL}/Apc_View/Amc_88/saveVendorCategory`,
      headers: {
        authorization: "Bearer " + props.access_token,
      },
    })
      .then((response) => {
        dispatch(SaveVendorCategoryRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(SaveVendorCategorySuccess(response));
          return response;
        } else if (response.status >= 401 && response.status < 500) {
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(SaveVendorCategoryError(error));
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (err = ele));
          return err;
        } else {
          dispatch(clearLogoutData());
        }
      });
}

//GET VENDOR CATEGORY BY ID
export const GetVendorCategoryDetailsActions = {
  FETCH_VENDOR_CATEGORY_DETAILS: "FETCH_VENDOR_CATEGORY_DETAILS",
  FETCH_VENDOR_CATEGORY_DETAILS_STATUS: "FETCH_VENDOR_CATEGORY_DETAILS_STATUS",
  FETCH_VENDOR_CATEGORY_DETAILS_FULFILLED:
    "FETCH_VENDOR_CATEGORY_DETAILS_FULFILLED",
  FETCH_VENDOR_CATEGORY_DETAILS_REJECTED:
    "FETCH_VENDOR_CATEGORY_DETAILS_REJECTED",
};

export function getVendorCategoryDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url:
        `${VendorService_URL}/Apc_View/Amc_88/findVendorCategoryById?vendorCategoryId=` +
        params.vendorCategoryId,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getVendorCategoryDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getVendorCategoryDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getVendorCategoryDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorCategoryDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorCategoryDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorCategoryDetailsError(err));
              break;
            case 500:
              dispatch(getVendorCategoryDetailsError("Server Error"));
              break;
            default:
              dispatch(getVendorCategoryDetailsError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getVendorCategoryDetailsRequest() {
  return {
    type: GetVendorCategoryDetailsActions.FETCH_VENDOR_CATEGORY_DETAILS,
    isPosting: true,
  };
}
export function getVendorCategoryDetailsError(error) {
  return {
    type: GetVendorCategoryDetailsActions.FETCH_VENDOR_CATEGORY_DETAILS_REJECTED,
    payload: error,
  };
}

export function getVendorCategoryDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetVendorCategoryDetailsActions.FETCH_VENDOR_CATEGORY_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getVendorCategoryDetailsStatus() {
  return (dispatch) => dispatch(getVendorCategoryDetailsStatusRequest());
}

export function getVendorCategoryDetailsStatusRequest() {
  return {
    type: GetVendorCategoryDetailsActions.FETCH_VENDOR_CATEGORY_DETAILS_STATUS,
  };
}

//GET Active Vendor Category List
export const GetActiveVendorCategoryActions = {
  FETCH_ACTIVE_VENDOR_CATEGORY: "FETCH_ACTIVE_VENDOR_CATEGORY",
  FETCH_ACTIVE_VENDOR_CATEGORY_STATUS: "FETCH_ACTIVE_VENDOR_CATEGORY_STATUS",
  FETCH_ACTIVE_VENDOR_CATEGORY_FULFILLED:
    "FETCH_ACTIVE_VENDOR_CATEGORY_FULFILLED",
  FETCH_ACTIVE_VENDOR_CATEGORY_REJECTED:
    "FETCH_ACTIVE_VENDOR_CATEGORY_REJECTED",
};

export function getActiveVendorCategoryList(params) {
  return (dispatch) =>
    axios({
      method: "POST",
      url: `${VendorService_URL}/Apc_View/Amc_89/getAllVendorCategoryByCompanyId?companyId=${params.companyId}`,
      headers: {
        transactionId: "1",
        "Content-Type": "application/json",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getActiveVendorCategoryListRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getActiveVendorCategoryListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getActiveVendorCategoryListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveVendorCategoryListError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveVendorCategoryListError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveVendorCategoryListError(err));
              break;
            case 500:
              dispatch(getActiveVendorCategoryListError("Server Error"));
              break;
            default:
              dispatch(getActiveVendorCategoryListError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getActiveVendorCategoryListRequest() {
  return {
    type: GetActiveVendorCategoryActions.FETCH_ACTIVE_VENDOR_CATEGORY,
    isPosting: true,
  };
}
export function getActiveVendorCategoryListError(error) {
  return {
    type: GetActiveVendorCategoryActions.FETCH_ACTIVE_VENDOR_CATEGORY_REJECTED,
    payload: error,
  };
}

export function getActiveVendorCategoryListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetActiveVendorCategoryActions.FETCH_ACTIVE_VENDOR_CATEGORY_FULFILLED,
      payload: props,
    });
  };
}

export function getActiveVendorCategoryListStatus() {
  return (dispatch) => dispatch(getActiveVendorCategoryListStatusRequest());
}
export function getActiveVendorCategoryListStatusRequest() {
  return {
    type: GetActiveVendorCategoryActions.FETCH_ACTIVE_VENDOR_CATEGORY_STATUS,
  };
}

//--------------------------------------------------------------//
//SAVE VENDOR REGISTER
export const SaveVendorRegisterActions = {
  SAVE_VENDOR_REGISTER: "SAVE_VENDOR_REGISTER",
  SAVE_VENDOR_REGISTER_STATUS: "SAVE_VENDOR_REGISTER_STATUS",
  SAVE_VENDOR_REGISTER_SUCCESS: "SAVE_VENDOR_REGISTER_SUCCESS",
  SAVE_VENDOR_REGISTER_FAILURE: "SAVE_VENDOR_REGISTER_FAILURE",
};

export function SaveVendorRegisterRequest() {
  return {
    type: SaveVendorRegisterActions.SAVE_VENDOR_REGISTER,
    isPosting: true,
  };
}

export function SaveVendorRegisterSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: SaveVendorRegisterActions.SAVE_VENDOR_REGISTER_SUCCESS,
      payload: props,
    });
  };
}

export function SaveVendorRegisterFailure(error) {
  return {
    type: SaveVendorRegisterActions.SAVE_VENDOR_REGISTER_FAILURE,
    payload: error,
  };
}

export function SaveVendorRegisterError(error) {
  return {
    type: SaveVendorRegisterActions.SAVE_VENDOR_REGISTER_FAILURE,
    payload: error,
  };
}

export function saveVendorRegister(data, access_token) {
  return (dispatch) =>
    axios({
      method: "post",
      data,
      url: `${VendorService_URL}/Apc_Persist/Amc_89/saveVendorMaster`,
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        dispatch(SaveVendorRegisterRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(SaveVendorRegisterSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(SaveVendorRegisterError(error));
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (err = ele));
          return err;
        } else {
          dispatch(clearLogoutData());
        }
      });
}

//GET VENDOR REGISTER BY ID
export const GetVendorRegisterDetailsActions = {
  FETCH_VENDOR_REGISTER_DETAILS: "FETCH_VENDOR_REGISTER_DETAILS",
  FETCH_VENDOR_REGISTER_DETAILS_STATUS: "FETCH_VENDOR_REGISTER_DETAILS_STATUS",
  FETCH_VENDOR_REGISTER_DETAILS_FULFILLED:
    "FETCH_VENDOR_REGISTER_DETAILS_FULFILLED",
  FETCH_VENDOR_REGISTER_DETAILS_REJECTED:
    "FETCH_VENDOR_REGISTER_DETAILS_REJECTED",
};

export function getVendorRegisterDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url:
        `${VendorService_URL}/Apc_View/Amc_89/getByIdvendorMaster?vendorId=` +
        params.vendorId,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getVendorRegisterDetailsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getVendorRegisterDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getVendorRegisterDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorRegisterDetailsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorRegisterDetailsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorRegisterDetailsError(err));
              break;
            case 500:
              dispatch(getVendorRegisterDetailsError("Server Error"));
              break;
            default:
              dispatch(getVendorRegisterDetailsError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getVendorRegisterDetailsRequest() {
  return {
    type: GetVendorRegisterDetailsActions.FETCH_VENDOR_REGISTER_DETAILS,
    isPosting: true,
  };
}
export function getVendorRegisterDetailsError(error) {
  return {
    type: GetVendorRegisterDetailsActions.FETCH_VENDOR_REGISTER_DETAILS_REJECTED,
    payload: error,
  };
}

export function getVendorRegisterDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetVendorRegisterDetailsActions.FETCH_VENDOR_REGISTER_DETAILS_FULFILLED,
      payload: props,
    });
  };
}

export function getVendorRegisterDetailsStatus() {
  return (dispatch) => dispatch(getVendorRegisterDetailsStatusRequest());
}

export function getVendorRegisterDetailsStatusRequest() {
  return {
    type: GetVendorRegisterDetailsActions.FETCH_VENDOR_REGISTER_DETAILS_STATUS,
  };
}

//DELETE VENDOR ADDRESS
export const DeleteVendorAddressActions = {
  DELETE_VENDOR_ADDRESS: "DELETE_VENDOR_ADDRESS",
  DELETE_VENDOR_ADDRESS_STATUS: "DELETE_VENDOR_ADDRESS_STATUS",
  DELETE_VENDOR_ADDRESS_FULFILLED: "DELETE_VENDOR_ADDRESS_FULFILLED",
  DELETE_VENDOR_ADDRESS_REJECTED: "DELETE_VENDOR_ADDRESS_REJECTED",
};
export function deleteVendorAddress(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${VendorService_URL}/Apc_State/Amc_89/deleteVendorAddress?vendorId=${params.vendorId}&addressId=${params.addressId}&status=${params.isActive}`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(deleteVendorAddressRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(deleteVendorAddressSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(deleteVendorAddressError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(deleteVendorAddressError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(deleteVendorAddressError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(deleteVendorAddressError(err));
              break;
            case 500:
              dispatch(deleteVendorAddressError("Server Error"));
              break;
            default:
              dispatch(deleteVendorAddressError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function deleteVendorAddressRequest() {
  return {
    type: DeleteVendorAddressActions.DELETE_VENDOR_ADDRESS,
    isPosting: true,
  };
}
export function deleteVendorAddressError(error) {
  return {
    type: DeleteVendorAddressActions.DELETE_VENDOR_ADDRESS_REJECTED,
    payload: error,
  };
}

export function deleteVendorAddressSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: DeleteVendorAddressActions.DELETE_VENDOR_ADDRESS_FULFILLED,
      payload: props,
    });
  };
}

//DELETE VENDOR CONTACT
export const DeleteVendorContactActions = {
  DELETE_VENDOR_CONTACT: "DELETE_VENDOR_CONTACT",
  DELETE_VENDOR_CONTACT_STATUS: "DELETE_VENDOR_CONTACT_STATUS",
  DELETE_VENDOR_CONTACT_FULFILLED: "DELETE_VENDOR_CONTACT_FULFILLED",
  DELETE_VENDOR_CONTACT_REJECTED: "DELETE_VENDOR_CONTACT_REJECTED",
};
export function deleteVendorContact(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${VendorService_URL}/Apc_State/Amc_89/deleteVendorContact?vendorId=${params.vendorId}&contactId=${params.vendorContactId}&status=${params.isActive}`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(deleteVendorContactRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(deleteVendorContactSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(deleteVendorContactError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(deleteVendorContactError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(deleteVendorContactError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(deleteVendorContactError(err));
              break;
            case 500:
              dispatch(deleteVendorContactError("Server Error"));
              break;
            default:
              dispatch(deleteVendorContactError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function deleteVendorContactRequest() {
  return {
    type: DeleteVendorContactActions.DELETE_VENDOR_CONTACT,
    isPosting: true,
  };
}
export function deleteVendorContactError(error) {
  return {
    type: DeleteVendorContactActions.DELETE_VENDOR_CONTACT_REJECTED,
    payload: error,
  };
}

export function deleteVendorContactSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: DeleteVendorContactActions.DELETE_VENDOR_CONTACT_FULFILLED,
      payload: props,
    });
  };
}

//GET VENDOR DOCUMENTS BY VENDOR ID
export const GetVendorTnCDocumentsActions = {
  FETCH_VENDOR_TNC_DOCUMENTS: "FETCH_VENDOR_TNC_DOCUMENTS",
  FETCH_VENDOR_TNC_DOCUMENTS_STATUS: "FETCH_VENDOR_TNC_DOCUMENTS_STATUS",
  FETCH_VENDOR_TNC_DOCUMENTS_FULFILLED: "FETCH_VENDOR_TNC_DOCUMENTS_FULFILLED",
  FETCH_VENDOR_TNC_DOCUMENTS_REJECTED: "FETCH_VENDOR_TNC_DOCUMENTS_REJECTED",
};

export function getVendorTnCDocuments(params) {
  const search = params.search || "";
  const active = params.active;
  const result = params.result || 20;
  const page = params.page || 0;
  const sortOrder = params.sortOrder === false ? "asc" : "desc";
  const sortField = params.sortField || "id";
  let obj;
  if (search !== "") {
    obj = {
      defaultSort: {
        sortField: sortField,
        sortOrder: sortOrder,
      },
      length: result,
      search: params.search,
      sort: params.sort,
      type: params.type,
      start: page,
      status: active,
      docStatus: params.docStatus,
      email: params.emailID,
      vendorId: params.vendorId,
    };
  } else {
    obj = {
      defaultSort: {
        sortField: sortField,
        sortOrder: sortOrder,
      },

      length: result,
      type: params.type,
      sort: params.sort,
      start: page,
      status: active,
      docStatus: params.docStatus,
      email: params.emailID,
      vendorId: params.vendorId,
    };
  }
  return (dispatch) =>
    axios({
      method: "post",
      url: `${VendorService_URL}/Apc_View/Amc_89/externalUserVendorDocumentsPagination`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
      data: obj,
    })
      .then((response) => {
        dispatch(getVendorTnCDocumentsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getVendorTnCDocumentsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getVendorTnCDocumentsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorTnCDocumentsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorTnCDocumentsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getVendorTnCDocumentsError(err));
              break;
            case 500:
              dispatch(getVendorTnCDocumentsError("Server Error"));
              break;
            default:
              dispatch(getVendorTnCDocumentsError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getVendorTnCDocumentsRequest() {
  return {
    type: GetVendorTnCDocumentsActions.FETCH_VENDOR_TNC_DOCUMENTS,
    isPosting: true,
  };
}
export function getVendorTnCDocumentsError(error) {
  return {
    type: GetVendorTnCDocumentsActions.FETCH_VENDOR_TNC_DOCUMENTS_REJECTED,
    payload: error,
  };
}

export function getVendorTnCDocumentsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetVendorTnCDocumentsActions.FETCH_VENDOR_TNC_DOCUMENTS_FULFILLED,
      payload: props,
    });
  };
}

export function getVendorTnCDocumentsStatus() {
  return (dispatch) => dispatch(getVendorTnCDocumentsStatusRequest());
}

export function getVendorTnCDocumentsStatusRequest() {
  return {
    type: GetVendorTnCDocumentsActions.FETCH_VENDOR_TNC_DOCUMENTS_STATUS,
  };
}

//SAVE VENDOR TERMS AND CONDITION DOCUMENTS
export const SaveVendorTnCDocumentsActions = {
  SAVE_VENDOR_TNC_DOCUMENTS: "SAVE_VENDOR_TNC_DOCUMENTS",
  SAVE_VENDOR_TNC_DOCUMENTS_STATUS: "SAVE_VENDOR_TNC_DOCUMENTS_STATUS",
  SAVE_VENDOR_TNC_DOCUMENTS_SUCCESS: "SAVE_VENDOR_TNC_DOCUMENTS_SUCCESS",
  SAVE_VENDOR_TNC_DOCUMENTS_FAILURE: "SAVE_VENDOR_TNC_DOCUMENTS_FAILURE",
};

export function SaveVendorTnCDocumentsRequest() {
  return {
    type: SaveVendorTnCDocumentsActions.SAVE_VENDOR_TNC_DOCUMENTS,
    isPosting: true,
  };
}

export function SaveVendorTnCDocumentsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: SaveVendorTnCDocumentsActions.SAVE_VENDOR_TNC_DOCUMENTS_SUCCESS,
      payload: props,
    });
  };
}

export function SaveVendorTnCDocumentsFailure(error) {
  return {
    type: SaveVendorTnCDocumentsActions.SAVE_VENDOR_TNC_DOCUMENTS_FAILURE,
    payload: error,
  };
}

export function SaveVendorTnCDocumentsError(error) {
  return {
    type: SaveVendorTnCDocumentsActions.SAVE_VENDOR_TNC_DOCUMENTS_FAILURE,
    payload: error,
  };
}

export function saveVendorTnCDocuments(data, access_token) {
  return (dispatch) =>
    axios({
      method: "post",
      data,
      url: `${VendorService_URL}/Apc_Persist/Amc_89/saveVendorDocuments`,
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        dispatch(SaveVendorTnCDocumentsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(SaveVendorTnCDocumentsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(SaveVendorTnCDocumentsError(error));
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (err = ele));
          return err;
        } else {
          dispatch(clearLogoutData());
        }
      });
}

//DELETE VENDOR Terms And Conditions Documents
export const DeleteVendorTnCDocumentsActions = {
  DELETE_VENDOR_TNC_DOCUMENTS: "DELETE_VENDOR_TNC_DOCUMENTS",
  DELETE_VENDOR_TNC_DOCUMENTS_STATUS: "DELETE_VENDOR_TNC_DOCUMENTS_STATUS",
  DELETE_VENDOR_TNC_DOCUMENTS_FULFILLED:
    "DELETE_VENDOR_TNC_DOCUMENTS_FULFILLED",
  DELETE_VENDOR_TNC_DOCUMENTS_REJECTED: "DELETE_VENDOR_TNC_DOCUMENTS_REJECTED",
};
export function deleteVendorTnCDocuments(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${VendorService_URL}/Apc_State/Amc_89/deleteVendorDocument?vendorId=${params.vendorId}&documentId=${params.documentId}&status=${params.isActive}`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(deleteVendorTnCDocumentsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(deleteVendorTnCDocumentsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(deleteVendorTnCDocumentsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(deleteVendorTnCDocumentsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(deleteVendorTnCDocumentsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(deleteVendorTnCDocumentsError(err));
              break;
            case 500:
              dispatch(deleteVendorTnCDocumentsError("Server Error"));
              break;
            default:
              dispatch(deleteVendorTnCDocumentsError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function deleteVendorTnCDocumentsRequest() {
  return {
    type: DeleteVendorTnCDocumentsActions.DELETE_VENDOR_TNC_DOCUMENTS,
    isPosting: true,
  };
}
export function deleteVendorTnCDocumentsError(error) {
  return {
    type: DeleteVendorTnCDocumentsActions.DELETE_VENDOR_TNC_DOCUMENTS_REJECTED,
    payload: error,
  };
}

export function deleteVendorTnCDocumentsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: DeleteVendorTnCDocumentsActions.DELETE_VENDOR_TNC_DOCUMENTS_FULFILLED,
      payload: props,
    });
  };
}

// ACTIVE VENDOR LIST

export const GetActiveVendorActions = {
  FETCH_ACTIVE_VENDORS: "FETCH_ACTIVE_VENDORS",
  FETCH_ACTIVE_VENDOR_STATUS: "FETCH_ACTIVE_VENDOR_STATUS",
  FETCH_ACTIVE_VENDOR_FULFILLED: "FETCH_ACTIVE_VENDOR_FULFILLED",
  FETCH_ACTIVE_VENDOR_REJECTED: "FETCH_ACTIVE_VENDOR_REJECTED",
};

export function getActiveVendorList(params) {
  var dataToPost = {
    defaultSort: {
      sortField: "vendorId",
      sortOrder: "desc",
    },
    sort: [],
    search: [],
    length: 1000,
    start: 0,
    status: true,
  };
  return (dispatch) =>
    axios({
      method: "POST",
      data: dataToPost,
      url: `${VendorService_URL}/Apc_View/Amc_89/getAllVendorMasterPagination`,
      headers: {
        transactionId: "1",
        "Content-Type": "application/json",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getActiveVendorListRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getActiveVendorListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getActiveVendorListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveVendorListError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveVendorListError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

              map.forEach((ele) => (err = ele));

              dispatch(getActiveVendorListError(err));
              break;
            case 500:
              dispatch(getActiveVendorListError("Server Error"));
              break;
            default:
              dispatch(getActiveVendorListError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getActiveVendorListRequest() {
  return {
    type: GetActiveVendorActions.FETCH_ACTIVE_VENDORS,
    isPosting: true,
  };
}
export function getActiveVendorListError(error) {
  return {
    type: GetActiveVendorActions.FETCH_ACTIVE_VENDOR_REJECTED,
    payload: error,
  };
}

export function getActiveVendorListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetActiveVendorActions.FETCH_ACTIVE_VENDOR_FULFILLED,
      payload: props,
    });
  };
}

export function getActiveVendorListStatus() {
  return (dispatch) => dispatch(getActiveVendorListStatusRequest());
}
export function getActiveVendorListStatusRequest() {
  return {
    type: GetActiveVendorActions.FETCH_ACTIVE_VENDOR_STATUS,
  };
}

//GET VIEW DOCUMENT
export const GetViewDocumentsActions = {
  FETCH_VIEW_DOCUMENTS: "FETCH_VIEW_DOCUMENTS",
  FETCH_VIEW_DOCUMENTS_STATUS: "FETCH_VIEW_DOCUMENTS_STATUS",
  FETCH_VIEW_DOCUMENTS_FULFILLED: "FETCH_VIEW_DOCUMENTS_FULFILLED",
  FETCH_VIEW_DOCUMENTS_REJECTED: "FETCH_VIEW_DOCUMENTS_REJECTED",
};

export function getViewDocumentDetails(params) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${VendorService_URL}/Apc_View/Amc_89/getVendorDocumentByVendorIdAndIdForExternalPortal?vendorId=${params.vendorId}&id=${params.id}`,
      headers: {
        transactionId: "1",
        Authorization: "Bearer " + params.access_token,
      },
    })
      .then((response) => {
        dispatch(getViewDocumentsRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(getViewDocumentSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getViewDocumentsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          switch (err.response.status) {
            case 400:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getViewDocumentsError(err));
              break;
            case 404:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getViewDocumentsError(err));
              break;
            case 406:
              map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
              map.forEach((ele) => (err = ele));
              dispatch(getViewDocumentsError(err));
              break;
            case 500:
              dispatch(getViewDocumentsError("Server Error"));
              break;
            default:
              dispatch(getViewDocumentsError("Unknown Error"));
              break;
          }
        } else {
          dispatch(clearLogoutData());
        }
      });
}

export function getViewDocumentsRequest() {
  return {
    type: GetViewDocumentsActions.FETCH_VIEW_DOCUMENTS,
    isPosting: true,
  };
}
export function getViewDocumentsError(error) {
  return {
    type: GetViewDocumentsActions.FETCH_VIEW_DOCUMENTS_REJECTED,
    payload: error,
  };
}

export function getViewDocumentSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: GetViewDocumentsActions.FETCH_VIEW_DOCUMENTS_FULFILLED,
      payload: props,
    });
  };
}

export function getViewDocumentStatus() {
  return (dispatch) => dispatch(getViewDocumentStatusRequest());
}

export function getViewDocumentStatusRequest() {
  return {
    type: GetViewDocumentsActions.FETCH_VIEW_DOCUMENTS_STATUS,
  };
}

//Upoad vender DOCUMENTS
export const UploadVenderDocumentActions = {
  UPLAOD_VENDER_DOCUMENT: "UPLAOD_VENDER_DOCUMENT",
  UPLAOD_VENDER_DOCUMENT_STATUS: "UPLAOD_VENDER_DOCUMENT_STATUS",
  UPLAOD_VENDER_DOCUMENT_SUCCESS: "UPLAOD_VENDER_DOCUMENT_SUCCESS",
  UPLAOD_VENDER_DOCUMENT_FAILURE: "UPLAOD_VENDER_DOCUMENT_FAILURE",
};

export function UploadVenderDocumentRequest() {
  return {
    type: UploadVenderDocumentActions.UPLAOD_VENDER_DOCUMENT,
    isPosting: true,
  };
}

export function UploadVenderDocumentSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: UploadVenderDocumentActions.UPLAOD_VENDER_DOCUMENT_SUCCESS,
      payload: props,
    });
  };
}

export function UploadVenderDocumentFailure(error) {
  return {
    type: UploadVenderDocumentActions.UPLAOD_VENDER_DOCUMENT_FAILURE,
    payload: error,
  };
}

export function UploadVenderDocumentError(error) {
  return {
    type: UploadVenderDocumentActions.UPLAOD_VENDER_DOCUMENT_FAILURE,
    payload: error,
  };
}

export function UploadVenderDocument(data, access_token) {
  return (dispatch) =>
    axios({
      method: "post",
      data,
      url: `${VendorService_URL}/Apc_Persist/Amc_89/uploadVendorDocumentsForExternalPortal?docId=${data.documentId}`,
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        dispatch(UploadVenderDocumentRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(UploadVenderDocumentSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(UploadVenderDocumentError(error));
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (err = ele));
          return err;
        } else {
          dispatch(clearLogoutData());
        }
      });
}


//Upoad vender DOCUMENTS
export const UploadVendorNewDocumentActions = {
  UPLAOD_VENDER_NEW_DOCUMENT: "UPLAOD_VENDER_NEW_DOCUMENT",
  UPLAOD_VENDER_NEW_DOCUMENT_STATUS: "UPLAOD_VENDER_NEW_DOCUMENT_STATUS",
  UPLAOD_VENDER_NEW_DOCUMENT_SUCCESS: "UPLAOD_VENDER_NEW_DOCUMENT_SUCCESS",
  UPLAOD_VENDER_NEW_DOCUMENT_FAILURE: "UPLAOD_VENDER_NEW_DOCUMENT_FAILURE",
};

export function UploadVendorNewDocumentRequest() {
  return {
    type: UploadVendorNewDocumentActions.UPLAOD_VENDER_NEW_DOCUMENT,
    isPosting: true,
  };
}

export function UploadVendorNewDocumentSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: UploadVendorNewDocumentActions.UPLAOD_VENDER_NEW_DOCUMENT_SUCCESS,
      payload: props,
    });
  };
}

export function UploadVendorNewDocumentFailure(error) {
  return {
    type: UploadVendorNewDocumentActions.UPLAOD_VENDER_NEW_DOCUMENT_FAILURE,
    payload: error,
  };
}

export function UploadVendorNewDocumentError(error) {
  return {
    type: UploadVendorNewDocumentActions.UPLAOD_VENDER_NEW_DOCUMENT_FAILURE,
    payload: error,
  };
}

export function UploadVendorNewDocument(data, access_token) {
  return (dispatch) =>
    axios({
      method: "post",
      data,
      url: `${VendorService_URL}/Apc_Persist/Amc_89/uploadRequestedVendorDocumentsForExternalPortal`,
      headers: {
        authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        dispatch(UploadVendorNewDocumentRequest());
        if (response.status >= 200 && response.status < 300) {
          dispatch(UploadVendorNewDocumentSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(UploadVendorNewDocumentError(error));
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));
          map.forEach((ele) => (err = ele));
          return err;
        } else {
          dispatch(clearLogoutData());
        }
      });
}

// Vendor Portal Dashboard Counts
export const GetVendorPortalDashboardActions = {
  GET_VENDOR_PORTAL_DASHBOARD: "GET_VENDOR_PORTAL_DASHBOARD",
  GET_VENDOR_PORTAL_DASHBOARD_SUCCESS: "GET_VENDOR_PORTAL_DASHBOARD_SUCCESS",
  GET_VENDOR_PORTAL_DASHBOARD_FAILURE: "GET_VENDOR_PORTAL_DASHBOARD_FAILURE",
};

export function getVendorPortalDashboardSuccess(payload) {
  return {
    type: GetVendorPortalDashboardActions.GET_VENDOR_PORTAL_DASHBOARD_SUCCESS,
    payload,
  };
}

export function getVendorPortalDashboardFailure(error) {
  return {
    type: GetVendorPortalDashboardActions.GET_VENDOR_PORTAL_DASHBOARD_FAILURE,
    payload: error,
  };
}

export function getVendorPortalDashboard(email, access_token) {
  return (dispatch) =>
    axios({
      method: "post",
      url: `${VendorService_URL}/get/VendorPortalDashboardByEmail?email=${encodeURIComponent(email)}`,
      headers: {
        Authorization: "Bearer " + access_token,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getVendorPortalDashboardSuccess(response.data));
        } else {
          dispatch(getVendorPortalDashboardFailure(response.statusText));
        }
      })
      .catch((err) => {
        dispatch(getVendorPortalDashboardFailure(err));
      });
}
